import {getMethod, postMethod, putMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/tickets', request, cancelToken)
}

async function getById(id, request) {
    return await getMethod(`/api/tickets/${id}`, request)
}

async function post(body) {
    return await postMethod('/api/tickets', body)
}

async function put(id, request) {
    return await putMethod(`/api/tickets/${id}`, request)
}

export {get, getById, post, put}
